import { useDispatch } from 'react-redux';

import { getAccPath } from 'api/auth';
import { LINK_COPIED } from 'constants/texts';
import { useSnackbar } from 'hooks/useSnackbar';
import { updateTourRequestRecentEventAction } from 'store/admin/itineraries';
import axiosApi from 'utils/axios';
import { copyTextToClipboard } from 'utils/common';
import { ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP } from 'utils/itineraries/functions';

import { ITINERARIES_ITEM_TYPES } from '../../../../../../../constants';

export type TailInfoResponse = {
  domain?: string;
  tail?: string;
  secure?: boolean;
};

export type UseProposalLinkProps = {
  itinerariesItemType: (typeof ITINERARIES_ITEM_TYPES)[keyof typeof ITINERARIES_ITEM_TYPES];
  itemId: string;
};

export function useProposalLink(props: UseProposalLinkProps) {
  const { itinerariesItemType, itemId } = props;

  const dispatch = useDispatch();
  const showSnackbar = useSnackbar();

  const handleCopyLink = (value: string) => {
    if (itinerariesItemType === ITINERARIES_ITEM_TYPES.GUEST_PORTAL) return;

    copyTextToClipboard(value);
    showSnackbar(LINK_COPIED);

    axiosApi
      .post(`${getAccPath()}/${ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType]}/${itemId}/copy_link`)
      .then(({ data = {} }) => {
        dispatch(updateTourRequestRecentEventAction({ id: itemId, recentEvent: data, itinerariesItemType }));
      })
      .catch(() => {
        console.error('Error occured when creating copy_link event', true);
      });
  };

  const handleSaveLink = async (tail: string) => {
    if (/[\\/:*?"<>|&%.'#[\]+=„]/.test(tail)) {
      throw "Invalid characters. You can't use spaces or any of the following \\/:*?\"<>|&%.'#[]+=„";
    }

    const source = ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType];
    await axiosApi.post(`${getAccPath()}/${source}/${itemId}/tail`, { tail });
  };

  const loadTailInfo = async () => {
    const source = ITINERARIES_ITEM_TYPE_TO_ROUTE_SEGMENT_MAP[itinerariesItemType];
    const resp = await axiosApi.get<{ data: TailInfoResponse }>(`${getAccPath()}/${source}/${itemId}/tail`);
    return resp.data.data;
  };

  return {
    onCopyLink: handleCopyLink,
    onSaveLink: handleSaveLink,
    loadTailInfo,
  };
}
